module.exports = __webpack_public_path__ + "fonts/MING_MSCS.7a55c81b.woff2";